import { useQuery } from 'react-query';
import { JobPermissionService } from '../../../services/v1/applicant_tracking/JobPermissionService';

export const useJobPublishPermissions = (jobId: number, expand?: string[]) =>
  useQuery({
    queryKey: ['job_publish_permissions', jobId, { expand: expand }],
    queryFn: () => JobPermissionService.publish(jobId, expand),
  });
